import { Controller } from '@hotwired/stimulus'

export default class AccountTypeMappingsItemController extends Controller<HTMLElement> {
  declare destroyValue: boolean
  declare readonly accountTypesTarget: HTMLSelectElement
  declare readonly destroyerTarget: HTMLInputElement
  declare readonly taxQualifiedTypesTarget: HTMLSelectElement

  static targets = ['accountTypes', 'destroyer', 'taxQualifiedTypes']
  static values = {
    destroy: Boolean,
    id: String,
  }

  connect() {
    window.addEventListener('account-type-mappings:reset-on-child', this.restoreForm)
    setTimeout(() => this.element.classList.remove('ring', 'ring-whitelabel-500'), 200)
    this.element.addEventListener('transitionend', this.#handleTransitionEnd)
  }

  disconnect() {
    window.removeEventListener('account-type-mappings:reset-on-child', this.restoreForm)
    this.element.removeEventListener('transitionend', this.#handleTransitionEnd)
  }

  makeDestroyed() {
    this.destroyValue = true
    this.dispatch('modified')
    this.#toggleAnimation('reverse').finished.then(() => {
      this.element.style.setProperty('display', 'none')
    })
  }

  restoreForm = () => {
    if (this.destroyValue === false) return
    this.destroyValue = false
    this.destroyerTarget.checked = false
    this.setSelect(this.accountTypesTarget, this.accountTypesTarget.dataset.initialValue)
    this.setSelect(this.taxQualifiedTypesTarget, this.taxQualifiedTypesTarget.dataset.initialValue)

    this.element.style.removeProperty('display')
    this.#toggleAnimation()
  }

  updateRedtailTypes($event: Event) {
    if ($event.target === this.taxQualifiedTypesTarget) {
      this.processTemplateOptions(this.taxQualifiedTypesTarget, document.getElementById('tax_qualified_type_options'))
    } else {
      this.processTemplateOptions(this.accountTypesTarget, document.getElementById('account_type_options'))
    }
  }

  processTemplateOptions(selectRef, templateRef) {
    if (!templateRef) return
    const selectedOptionValue = selectRef.options[selectRef.selectedIndex].value
    const types = templateRef.content.cloneNode(true)

    selectRef.innerHTML = ''
    selectRef.appendChild(types)

    if (selectedOptionValue) {
      this.setSelect(selectRef, selectedOptionValue)
    }
  }

  setSelect(el: HTMLSelectElement, value?: string) {
    const targetOption = el.querySelector<HTMLOptionElement>(`[value='${value}']`)
    if (!targetOption) return
    if (!targetOption.selected) targetOption.selected = true
  }

  #handleTransitionEnd = (event: Event) => {
    if (event.propertyName === 'opacity') {
      if (this.destroyValue) {
        this.element.style.setProperty('display', 'none')
      } else {
        this.element.removeAttribute('style')
      }
    }
  }

  #toggleAnimation(direction: PlaybackDirection) {
    direction ??= 'normal'
    const options: KeyframeAnimationOptions = {
      direction,
      duration: 300,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      fill: 'both',
    }
    return this.element.animate(
      [
        { opacity: 0, transform: 'scale(0.95)' },
        { opacity: 1, transform: 'scale(1)' },
      ],
      options,
    )
  }
}
